export interface Props {
  scrollDirection: "top" | "bottom"
  handleClickScroll: () => void
  styleButton?: React.CSSProperties
}
export const ButtonScroll = (props: Props) => {
  const { scrollDirection, handleClickScroll, styleButton } = props
  return (
    <button
      className="scroll-btn"
      onClick={handleClickScroll}
      style={{
        bottom: 10,
        ...styleButton,
      }}
    >
      {scrollDirection === "top" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.0702 9.57L12.0002 3.5L5.93018 9.57"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 20.4999V3.66992"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.0702 14.4302L12.0002 20.5002L5.93018 14.4302"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 3.5V20.33"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </button>
  )
}
